module.exports = __webpack_public_path__ + "img/vacuum-robot.b30b6e77.svg";